import {useState} from 'react';
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from '@chekin/guestapp-ui-kit';
import {Plus, Minus} from 'lucide-react';

type Props = {
  className?: string;
  question: string;
  answer: string;
};

export const AskedQuestion = ({question, answer}: Props) => {
  const [open, setOpen] = useState(true);
  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className="flex flex-col gap-4 leading-6"
    >
      <CollapsibleTrigger className="flex items-center justify-between gap-2">
        <span className="font-semibold text-start">{question}</span>
        {open ? <Minus size={24} /> : <Plus size={24} />}
      </CollapsibleTrigger>
      <CollapsibleContent className="text-[var(--font-secondary)] text-start">
        {answer}
      </CollapsibleContent>
    </Collapsible>
  );
};
